import { useEffect } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { PulseCard, Row } from '~/commonComponents';
import { RejectPopupConfirmation } from '~/components/PermanentJobsV2/JobOverview/components/CandidateTabView/CandidateListTable/RejectPopup';
import { useToggle } from '~/hooks';
import { CloseCircleOutlineIcon } from '~/images/icons';

interface IRejectProfessionalProps {
  isRejected: boolean;
  professional: {
    firstName: string;
    fullName: string;
    id: string;
  };
}

export const RejectProfessional = ({
  isRejected: inputIsRejected,
  professional,
}: IRejectProfessionalProps) => {
  const [isRejected, controls] = useToggle();
  const [isRejectOpen, controlsReject] = useToggle();

  useEffect(() => {
    controls.set(inputIsRejected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputIsRejected]);

  return (
    <>
      <PulseCard
        ActionComponent={() =>
          isRejected ? (
            <Row
              alignItems="center"
              gap={8}
              justifyContent="center"
              paddingBlock={11}
              paddingInline={24}
            >
              <CloseCircleOutlineIcon color={colors.neutral[400]} />
              <Typography as="span" bold color={colors.neutral[400]} size="body_large">
                Rejected Professional
              </Typography>
            </Row>
          ) : (
            <Row
              alignItems="center"
              backgroundColor={colors.neutral[100]}
              borderRadius={25}
              className="shadow"
              cursor="pointer"
              gap={6}
              justifyContent="center"
              marginBottom={16}
              paddingBlock={11}
              paddingInline={16}
              width={228}
              style={{
                boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.15), 0 6px 10px 2px rgba(0, 0, 0, 0.15)',
              }}
              onClick={controlsReject.setOn}
            >
              <CloseCircleOutlineIcon color={colors.primary[500]} />
              <Typography
                as="span"
                bold
                color={colors.primary[500]}
                size="body_large"
                style={{ whiteSpace: 'nowrap' }}
              >
                Reject Professional
              </Typography>
            </Row>
          )
        }
        isItalic={!isRejected}
        description={
          isRejected ? (
            <>
              <strong>{professional.firstName}</strong>’s application has been archived under
              Rejected in the
              <br />
              Candidates tab of Manage Jobs.
            </>
          ) : (
            'Rejected professionals will be excluded from future consideration.'
          )
        }
        title={
          isRejected
            ? 'Rejected Successfully'
            : 'Would you like to reject this professional for this job?'
        }
      />
      {isRejectOpen && (
        <RejectPopupConfirmation
          controls={controlsReject}
          candidateId={professional.id}
          disableSuccessPopup
          professionalName={professional.fullName}
        />
      )}
    </>
  );
};
